// 下载任务管理
export const DOWNLOAD_ADD_SOFT = 'DOWNLOAD_ADD_SOFT';
export const DOWNLOAD_ADD_SOFT_LIST = 'DOWNLOAD_ADD_SOFT_LIST';
export const DOWNLOAD_CANCEL_SOFT = 'DOWNLOAD_CANCEL_SOFT';
export const DOWNLOAD_GET_SOFT_LIST = 'DOWNLOAD_GET_SOFT_LIST';
export const DOWNLOAD_GET_SOFT_LIST_SUCCESS = 'DOWNLOAD_GET_SOFT_LIST_SUCCESS';
export const DOWNLOAD_UPDATE_SOFT_LIST_STATE = 'DOWNLOAD_UPDATE_SOFT_LIST_STATE';
export const DOWNLOAD_UPDATE_SOFT_LIST_PROGRESS = 'DOWNLOAD_UPDATE_SOFT_LIST_PROGRESS';
export const DOWNLOAD_SHOW_FILE_ERROR = 'DOWNLOAD_SHOW_FILE_ERROR';
export const DOWNLOAD_SHOW_SIM = 'DOWNLOAD_SHOW_SIM';
export const DOWNLOAD_CANENL = 'DOWNLOAD_CANENL';
